<template>
  <div>
    <v-row
      v-for="k in ligandsLoaded"
      :key="k"
    >
      <v-col cols="6">
        <v-checkbox
          :label="ligands[k].name"
          :checked="ligands[k].visible"
          @change="toggleLigand(k)"
        />
      </v-col>
      <v-col cols="6">
        <v-btn
          style="float: right"
          elevation="2"
          @click="zoomLigand(k)"
        >
          Zoom
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  export default {
    name: 'Ligand',
    computed: {
      ligandsLoaded () {
        return this.$store.state.ligands_loaded
      },
      ligands () {
        return this.$store.state.ligands_available
      },
    },
    mounted () {
    },
    methods: {
      toggleLigand (ligandname) {
        this.$store.dispatch('toggleLigand', { ligandname: ligandname })
      },
      zoomLigand (ligandname) {
        this.$store.dispatch('zoomLigand', { ligandname: ligandname })
      },
    },
  }
</script>

<style scoped>
button {
  height: 21px;
  width: 55px;
}
</style>
